'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTranslate = require('@gandi/react-translate');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./LayerOrientation.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LayerOrientation(_ref) {
  var __ = _ref.__;

  return _react2.default.createElement(
    'div',
    { className: 'LayerOrientation' },
    _react2.default.createElement(
      'div',
      { className: 'LayerOrientation__center' },
      _react2.default.createElement('span', { className: 'LayerOrientation__portrait icon-TurnPhone', 'aria-hidden': 'true' })
    ),
    _react2.default.createElement(
      'span',
      { className: 'sr-only' },
      __('LayerOrientation|Use portrait')
    )
  );
}

LayerOrientation.propTypes = {
  __: _propTypes2.default.func.isRequired // @see https://github.com/Gandi/react-translate
};

LayerOrientation.defaultProps = {};

exports.default = (0, _reactTranslate.withTranslator)()(LayerOrientation);


//////////////////
// WEBPACK FOOTER
// ./~/ui-kit/src/components/LayerOrientation/LayerOrientation.js
// module id = 1167
// module chunks = 0